import { render, staticRenderFns } from "./InfoTableTemplate.vue?vue&type=template&id=17f1ab4b&"
import script from "./InfoTableTemplate.vue?vue&type=script&lang=js&"
export * from "./InfoTableTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports